<mat-card appearance="outlined" style="display: flex; flex-direction: column; width: 100%">
	<div style="flex-direction: row; display: flex">
		<app-vinavon-button>
			<button (click)="file.click()" [ngClass]="currTermin ? 'btnenabled' : 'btndisabled'" mat-raised-button>
				<mat-icon>upload_file</mat-icon>
				{{ "Bild Hochladen" }}
			</button>
			<input #file (change)="saveImage($event)" accept="image/*" hidden="hidden" multiple type="file"/>
		</app-vinavon-button>
		<app-vinavon-button>
			<button (click)="cam.click()" [ngClass]="currTermin ? 'btnenabled' : 'btndisabled'" mat-raised-button>
				<mat-icon>photo_camera</mat-icon>
				{{ "Foto erstellen" }}
			</button>
			<input #cam (change)="saveImage($event)" accept="image/*" capture="environment" hidden="hidden" type="file"/>
		</app-vinavon-button>
	</div>
	<div class="contentContainer">
		<div>
			<ng-image-slider *ngIf="(imageObject | async)?.length" [images]="(imageObject |async)!"></ng-image-slider>
		</div>
		
		<div *ngIf="(terminBilder | async)?.length" class="mat-elevation-z8" style="overflow-y: auto">
			<table [dataSource]="(terminBilder | async)!" class="mat-elevation-z8" mat-table>
				<ng-container matColumnDef="picSynced">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.synced" | translate }}
					</th>
					
					<td *matCellDef="let element" mat-cell>
						<ng-container>
							<fa-icon *ngIf="element.uploaded" [icon]="faBolt" style="font-size: 1.5em; color:lightgray"></fa-icon>
						</ng-container>
					</td>
				</ng-container>
				
				<!-- Art Column -->
				<ng-container matColumnDef="pic_art">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.art" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						<img alt="img" src="/assets/obj_activity_icons/{{ element.imageFile }}"/>
					</td>
				</ng-container>
				
				<!-- Beschreibung Column -->
				<ng-container matColumnDef="pic_desc">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.beschreibung" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						<mat-form-field>
							<input (keyup)="saveDescription(element)" [(ngModel)]="element.description" [value]="element.name" matInput placeholder="Name"/>
						</mat-form-field>
					</td>
				</ng-container>
				
				<!-- Dateiname Column -->
				<ng-container matColumnDef="pic_filename">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.dateiname" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						{{ element.documentName }}
					</td>
				</ng-container>
				
				<!-- Erstell-Datum Column -->
				<ng-container matColumnDef="pic_bearbeitet">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.erstelltAm" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						{{ element.formattedDate }}
					</td>
				</ng-container>
				
				<!-- Erstellt durch Column -->
				<ng-container matColumnDef="pic_creator">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.erstelltVon" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>{{ element.creator }}</td>
				</ng-container>
				
				<!-- Name Column -->
				<ng-container matColumnDef="pic_name">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.name" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>{{ element.lastName }} {{ element.firstName }}</td>
				</ng-container>
				
				<!-- Vorname Column -->
				<ng-container matColumnDef="pic_vorname">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.vorname" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>{{ element.firstName }}</td>
				</ng-container>
				
				<!-- Ansprechname Column -->
				<ng-container matColumnDef="pic_ansprechname">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.ansprechname" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						{{ element.ansprechName }} {{ element.ansprechVorname }}
					</td>
				</ng-container>
				
				<!-- Ansprechvorname Column -->
				<ng-container matColumnDef="pic_ansprechvorname">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.ansprechvorname" | translate }}
					</th>
					<td *matCellDef="let element" mat-cell>
						{{ element.ansprechVorname }}
					</td>
				</ng-container>
				
				<!-- Bild löschen -->
				<ng-container matColumnDef="pic_delete">
					<th *matHeaderCellDef mat-header-cell>
						{{ "MAIN_APP_SERVICE_APP.löschen" | translate }}
					</th>
					
					<td *matCellDef="let element" mat-cell>
						<ng-container *ngIf="!element.uploaded && element.uploader === employeeID">
							<mat-icon (click)="deleteImage(element)">delete</mat-icon>
						</ng-container>
					</td>
				</ng-container>
				
				<tr *matHeaderRowDef="displayedDokuColumns" mat-header-row></tr>
				<tr (click)="openPicture(row)" *matRowDef="let row; columns: displayedDokuColumns" mat-row></tr>
			</table>
		</div>
	</div>
</mat-card>
